import { render, staticRenderFns } from "./UjianProcess.vue?vue&type=template&id=6ad298ee&scoped=true"
import script from "./UjianProcess.vue?vue&type=script&lang=js"
export * from "./UjianProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad298ee",
  null
  
)

export default component.exports